module.exports = __webpack_public_path__ + "static/media/raiden.1298604c.svg";


//////////////////
// WEBPACK FOOTER
// ./client/src/img/coins/raiden.svg
// module id = 1148
// module chunks = 0